import HasPrequalScreen from './HasPrequalScreen'
import NoPrequalScreen from './NoPrequalScreen'
import LoadingBlock from 'src/Components/shared/Loading/LoadingBlock'
import styles from './PrequalTab.module.scss'
import { selectLoading, selectFirstPrequal } from 'src/store/selectors/prequal'
import { useSelector } from 'react-redux'
import { selectModalMethod } from 'src/store/selectors/affordability'
import { PREQUAL } from 'src/constants/affordability'

export const PrequalTab = () => {
  const hasPrequal = Boolean(useSelector(selectFirstPrequal))
  const loading = useSelector(selectLoading)
  const modalMethod = useSelector(selectModalMethod)

  if (loading) {
    return <LoadingBlock />
  }
  if (modalMethod !== PREQUAL) {
    return null
  }
  return (
    <div className={styles.root}>
      {hasPrequal ? <HasPrequalScreen /> : <NoPrequalScreen />}
    </div>
  )
}
